module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/inner-pages/blog-magazine-93366efa275586a0cc0f5c0014af8d2b.png";